import { alias, createModelSchema, list } from "serializr";
import { SmartOfferBundle } from "../bundle-core/SmartOfferBundle";
import { ProductModel } from "../../product/ProductModel";
import { SmartOfferBundleKind } from "../bundle-core/SmartOfferBundleKind";
import { SmartOfferBundleShopType } from "./SmartOfferBundleShopType";
import { RewardBunch } from "@/modules/redactor/models/reward/RewardBunch";
import { TriggerUtils } from "@/modules/redactor/models/trigger/core/TriggerUtils";
import {Schema} from "@/common/Schema";

export class SmartOfferBundleShop extends SmartOfferBundle {

    constructor() {
        super(SmartOfferBundleKind.SHOP);

        this._type = SmartOfferBundleShopType.NONE;

        this._defaultRewardIcon = false;

        this._reward = null;
        this._products = [];
        this._triggersProgress = [];
        this._segment = null;
    }

    get type() {
        return this._type;
    }

    set type(value) {

        if (this._type && !this._type.equal(value)) {
            this._products = [];
        }

        this._type = value;
    }

    get reward() {
        return this._reward;
    }

    set reward(value) {
        this._reward = value;
    }

    get products() {
        return this._products;
    }

    set products(value) {
        this._products = value;
    }

    get triggersProgress() {
        return this._triggersProgress;
    }

    set triggersProgress(value) {
        this._triggersProgress = value;
    }

    get defaultRewardIcon() {
        return this._defaultRewardIcon;
    }

    set defaultRewardIcon(value) {
        this._defaultRewardIcon = value;
    }

    get segment() {
      return this._segment;
    }

    set segment(value) {
      this._segment = value;
    }



    valid() {
        if (!SmartOfferBundleShopType.is(this.type) || SmartOfferBundleShopType.isNone(this.type)) {
            return false;
        }

        if (!this.products || this.products.length === 0) {
            return false;
        }

        if (this.products.some(v => !v || !v.valid())) {
            return false;
        }

        if (this.reward && !this.reward.valid()) {
            return false;
        }

        if (this.triggersProgress.some(v => !v || !v.valid())) {
            return false;
        }

        return super.valid();
    }

    empty() {

        if (super.empty()) {
            return true;
        }

        return !this.products || this.products.length === 0;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new SmartOfferBundleShop());
        } else if (target instanceof SmartOfferBundleShop) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(SmartOfferBundleShop, {
    _type: alias("type", SmartOfferBundleShopType.schema()),
    _reward: alias("reward", RewardBunch.schema()),
    _products: alias("products", list(ProductModel.schema())),
    _triggersProgress: alias("triggers_progress", TriggerUtils.schema()),
    _defaultRewardIcon: alias("default_reward_icon", Schema.primitive()),
    _segment: alias("segment", Schema.primitive()),
});
